module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"EmployeeList":{"heading":"Zaměstnanci"}},"en":{"EmployeeList":{"heading":"Employees"}}}')
  delete Component.options._Ctor
}
